import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { respuestaMensaje, Mensaje } from '@/Interfaces/shared/mensaje';
import { GlobalService } from '@/Servicios';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input() Mensaje: Mensaje
  @Output() respuestaMensaje: EventEmitter<respuestaMensaje> = new EventEmitter();

  titulo: string = '';
  notificaciones:any;
  constructor(private global:GlobalService) { 
    this.notificaciones = this.global.notificaciones;
  }

  ngOnInit() {
   this.titulo = 'Notificaciones';
      
  }
  accion(accion: string) {
    switch(accion){
      case 'cerrar':{
        this.respuestaMensaje.emit(respuestaMensaje.Cerrar);
        break;
      }
      case 'aceptar':{
        this.respuestaMensaje.emit(respuestaMensaje.Aceptar);
        break;
      }
    }
  }
}
